import React from "react";
import Card from "components/card";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import SelectOption from "components/select/SelectOption";
import Button from "components/button";
import { Send } from "lucide-react";

const SupportTicket = ({
    onClose,
}) => {
    const [form] = Form.useForm();

    const onSubmit = (formData) => {};

    return (
        <Card className="grid w-full gap-4 border rounded-lg shadow-lg p-6">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <h2 className="text-lg leading-none font-semibold">
                    Submit New IT Support Ticket
                </h2>
                <p className="text-slate-700 text-sm">
                    Describe your technical issue and our IT team will assist you
                </p>
            </div>
            <Form
                form={form}
                layout="vertical" 
                onFinish={onSubmit}
            >
                <div className="space-y-4 py-4">
                    <div className="space-y-2">
                        <FormItem
                            label="Issue Title"
                            rules={[requiredField()]}
                        >
                            <Input
                                className="input-field"
                                placeholder="Brief description of the issue"
                            />
                        </FormItem>
                        <FormItem
                            label="Category"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select category"
                                options={[
                                    {label:"Network", value: 0},
                                    {label:"Account", value: 1},
                                    {label:"Software", value: 2},
                                    {label:"Hardware", value: 3},
                                    {label:"Mobile", value: 4},
                                    {label:"Printer", value: 5},
                                    {label:"Other", value: 6},
                                ]}
                            />
                        </FormItem>
                        <FormItem
                            label="Priority"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select priority"
                                options={[
                                    {label:"Low", value: 0},
                                    {label:"Medium", value: 1},
                                    {label:"High", value: 2},
                                ]}
                            />
                        </FormItem>
                        <FormItem
                            label="Description"
                            rules={[requiredField()]}
                        >
                            <TextArea
                                placeholder="Provide detailed information about your issue..."
                                rows={5}
                                className="input-field"
                                maxLength={255}
                            />
                        </FormItem>
                    </div>
                    <div className="flex gap-2 pt-4">
                        <Button
                            onClick={onSubmit}
                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg 
                                        text-sm font-medium transition-all outline-none hover:bg-emerald-500/90 h-9 px-4 py-2 flex-1 
                                        bg-gradient-to-r from-blue-600 to-cyan-600 hover:shadow-none
                                        hover:from-blue-700 hover:to-cyan-700 text-white"
                        >
                            <Send className="w-4 h-4 mr-2"/>
                            Submit Ticket
                        </Button>
                        <Button
                            onClick={() => onClose?.()}
                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium
                                        transition-all shrink-0 bg-white text-slate-900 
                                        hover:bg-slate-100 hover:shadow-none hover:text-slate-900  h-9 px-4 py-2 border-2"
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Form>
        </Card>
    )
};
export default SupportTicket;